module.exports = __webpack_public_path__ + "static/media/report_2t.82497ad1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Hotel/components/Documentation/images/report_2t.jpg
// module id = 413
// module chunks = 0